<template>
    <div class="action-title">
        <router-link :to="link" tag="div">
            <slot name="icon">
                <font-awesome-icon v-if="icon" :icon="icon" class="action-icon" />
            </slot>
            <span><slot /></span>
        </router-link>
    </div>
</template>

<script>
export default {
    props: {
        icon: String,
        link: String,
    },
};
</script>

<style lang="scss">
.actions {
    flex-shrink: 0;
    flex-grow: 0;
    display: flex;
    flex-direction: column;
    margin-top: auto;
    .action-title {
        padding: 10px 10px 10px 20px;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        > div {
            font-size: 13px;
            line-height: 13px;
            font-weight: 600;
            color: #2a2a2a;
            &.router-link-active {
            }
        }

        &:hover span {
            color: #6c3e91;
        }

        .action-icon {
            color: #9ca5b0;
            font-size: 16px;
            line-height: 16px;
            width: 14px;
            height: 16px;
            padding-right: 14px;
        }
        &.action-separator {
            padding: 0;
            margin: 0 10px 10px 20px;
            border: 1px solid #d4d8dd;
            opacity: 0.5;
            box-shadow: 0 1px 4px 2px rgba(212, 216, 221, 0.43);
        }

        .router-link-active {
            span {
                color: #6c3e91;
            }
            .action-icon {
                color: #6c3e91;
            }
        }
    }
}
</style>
